export const MODULE_NAME = '@pressreader/appcore';

export const COOKIE_TARGETPLATFORM_KEY = 'targetPlatform';
export const COOKIE_TARGETPLATFORM_EXPIRES_IN_DAYS = 365;

export const COOKIE_FACELIFT_ENABLED_KEY = 'facelift';
export const COOKIE_FACELIFT_ENABLED_EXPIRES_IN_DAYS = 365;

/** Gates features that are still in development, so a host opts into them explicitly. */
export const EXPERIMENTAL_FEATURES_FEATURE_FLAG = 'features.app.experimental.enabled';
